import { render, staticRenderFns } from "./HeaderBody.vue?vue&type=template&id=1dbe5496&scoped=true"
import script from "./HeaderBody.vue?vue&type=script&lang=js"
export * from "./HeaderBody.vue?vue&type=script&lang=js"
import style0 from "./HeaderBody.vue?vue&type=style&index=0&id=1dbe5496&prod&lang=less&scoped=true"
import style1 from "./HeaderBody.vue?vue&type=style&index=1&id=1dbe5496&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe5496",
  null
  
)

export default component.exports